import { Dispatch } from 'redux';
import {
    CANNED_QUESTION_EMAIL_ADDRESS,
    CANNED_QUESTION_FIRST_NAME,
    CANNED_QUESTION_LAST_NAME,
    getFieldName,
} from '../containers/checkout/constants';
import { PrefillSurveyFieldsInfo } from '../models/survey';
import { CheckoutState } from '../state';
import { changeSurveyField } from '../utils/surveys';

export const prefillAttendeeBasicInfoFields =
    ({
        attendeeId,
        emailToPrefill,
        firstNameToPrefill,
        lastNameToPrefill,
        formName,
    }: Pick<
        PrefillSurveyFieldsInfo,
        | 'formName'
        | 'emailToPrefill'
        | 'firstNameToPrefill'
        | 'lastNameToPrefill'
    > & { attendeeId: string }) =>
    (dispatch: Dispatch<CheckoutState>) => {
        if (!formName) {
            return;
        }

        if (emailToPrefill) {
            dispatch(
                changeSurveyField(
                    getFieldName(attendeeId, CANNED_QUESTION_EMAIL_ADDRESS),
                    emailToPrefill,
                    formName,
                ),
            );
        }

        if (firstNameToPrefill) {
            dispatch(
                changeSurveyField(
                    getFieldName(attendeeId, CANNED_QUESTION_FIRST_NAME),
                    firstNameToPrefill,
                    formName,
                ),
            );
        }

        if (lastNameToPrefill) {
            dispatch(
                changeSurveyField(
                    getFieldName(attendeeId, CANNED_QUESTION_LAST_NAME),
                    lastNameToPrefill,
                    formName,
                ),
            );
        }
    };
